import { cloneDeep, get } from 'lodash'
import { Message } from 'element-ui'

export default class SocketManager {
  constructor(options = {}) {
    this.socketObject = null
    this.socketLineList = []
    this.options = options
    this.onDataChange = options.onDataChange // 数据变化时的回调函数
    this.startSocket = false
  }

  connect(sourceId) {
    const socketPath = get(
      Wiz,
      'globalSettings.dynamicModules.modules["visualization-cockpit"].config'
    )?.PersonnelPositionPath || ''

    if (!socketPath) {
      Message.warning('未配置websocket地址')
      return
    }

    const socketUrl = `${socketPath}/Position?modelId=${sourceId}&siteId=3a0743fd-2f61-51c2-3bfd-415e973ef230`
    this.socketObject = new WebSocket(socketUrl)
    this.initMessageHandler()
  }

  initMessageHandler() {
    this.socketObject.onmessage = async ({ data }) => {
      if (data.indexOf('连接成功') === 0) {
        return
      }

      const res = cloneDeep(JSON.parse(data))
      const oldSocketLineList = [...this.socketLineList]
      let hasChanges = false

      if (res.onLineList.length !== 0) {
        this.socketLineList = res.onLineList
        hasChanges = true
      } else if (res.positionList.length !== 0) {
        const positionMap = new Map(
          res.positionList.map((pos) => { return [pos.tagId, pos] })
        )

        this.socketLineList = this.socketLineList.map((socketItem) => {
          const matchedPosition = positionMap.get(socketItem.tagId)
          if (matchedPosition) {
            return {
              ...socketItem,
              x: matchedPosition.x,
              y: matchedPosition.y,
              z: matchedPosition.z,
            }
          }
          return socketItem
        })

        hasChanges = this.socketLineList.some(
          (item, index) => {
            return item.x !== oldSocketLineList[index].x ||
              item.y !== oldSocketLineList[index].y ||
              item.z !== oldSocketLineList[index].z
          }
        )
      }

      if (hasChanges && this.onDataChange) {
        this.onDataChange({
          socketLineList: this.socketLineList,
          isFirstTime: !this.startSocket,
        })
        this.startSocket = true
      }
    }
  }

  disconnect() {
    if (this.socketObject) {
      this.socketObject.close()
      this.socketObject = null
    }
  }

  getSocketLineList() {
    return this.socketLineList
  }
}
